import { render, staticRenderFns } from "./SnCreationForm.vue?vue&type=template&id=38ece298&scoped=true&"
import script from "./SnCreationForm.vue?vue&type=script&lang=js&"
export * from "./SnCreationForm.vue?vue&type=script&lang=js&"
import style0 from "./SnCreationForm.vue?vue&type=style&index=0&id=38ece298&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ece298",
  null
  
)

export default component.exports